import { FC, useEffect, useState } from "react";
import { Box, Typography } from "@material-ui/core";
import { useStyles } from "../styles";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { daUpdateDateSettings, daUpdateSettings } from "actions/daAndFleetActions";
import { useDispatch } from "react-redux";
import { FilterSwitch } from "componentsNew/elements/TabSwitch";
import { DateFilter } from "componentsNew/elements/DateFilter";
import { handleGetDAStatusStats } from "../requests";
import Loader from "router/components/Loader";
import GraphStatsBox from "../GraphStatsBox";

const DaGraphSection: FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    driverData: { driverList, driverListFilters },
  } = useTypeSelectors((state) => state.daAndFleets);
  const [loading, setLoading] = useState(false);
  const [requestData, setRequestData] = useState<any>(null);

  const stations = driverListFilters?.stations?.join("_");

  useEffect(() => {
    if (stations) {
      const params = {
        ...(driverListFilters?.selectType === "date" && {
          day: driverListFilters?.dateFilters?.date,
        }),
        ...(driverListFilters?.selectType === "month" && {
          month: +Number(driverListFilters?.dateFilters?.month.split("-")[1]),
          year: +Number(driverListFilters?.dateFilters?.month.split("-")[0]),
        }),
        ...(driverListFilters?.selectType === "week" && {
          week: +Number(driverListFilters?.dateFilters?.week.split("-W")[1]) - 1,
          year: +Number(driverListFilters?.dateFilters?.week.split("-W")[0]),
        }),
        ...(driverListFilters?.selectType === "year" && {
          year: +Number(driverListFilters?.dateFilters?.year),
        }),
        stations
      };
      handleGetDAStatusStats(params, setLoading, setRequestData);
    }
  }, [
    driverListFilters?.selectType,
    driverListFilters?.dateFilters?.date,
    driverListFilters?.dateFilters?.week,
    driverListFilters?.dateFilters?.month,
    driverListFilters?.dateFilters?.year,
    driverList,
    stations,
  ]);

  const handleChangeSelectType = (string: string) => {
    dispatch(daUpdateSettings({ selectType: string }));
  };

  const handleChangeDate = (date: string) => dispatch(daUpdateDateSettings({ date }));
  const handleChangeWeek = (week: string) => dispatch(daUpdateDateSettings({ week }));
  const handleChangeMonth = (month: string) => dispatch(daUpdateDateSettings({ month }));
  const handleChangeYear = (year: string) => dispatch(daUpdateDateSettings({ year }));

  return (
    <Box className={classes.graphSection}>
      <Loader isLoading={loading} />
      <Box className={classes.graphSectionContent}>
        <Typography className={classes.graphSectionTitle}>Driver Status</Typography>
        <Box className={classes.filterInputs}>
          <DateFilter
            type={driverListFilters?.selectType}
            dateValue={driverListFilters?.dateFilters?.date}
            weekValue={driverListFilters?.dateFilters?.week}
            monthValue={driverListFilters?.dateFilters?.month}
            yearValue={driverListFilters?.dateFilters?.year}
            dateChange={handleChangeDate}
            weekChange={handleChangeWeek}
            monthChange={handleChangeMonth}
            yearChange={handleChangeYear}
            isSmallSize
          />
          <FilterSwitch
            type={driverListFilters?.selectType}
            enabledFilters={["month", "date", "week", "year"]}
            action={handleChangeSelectType}
            isSmallSize
          />
        </Box>
      </Box>
      <Box className={classes.graphStats}>
        <GraphStatsBox
          title={"Active"}
          count={requestData?.active_count}
          dataList={requestData?.data_list?.map((item: any) => item?.max_active_count) || []}
        />
        <GraphStatsBox
          title={"Inactive"}
          count={requestData?.inactive_count}
          dataList={requestData?.data_list?.map((item: any) => item?.max_inactive_count) || []}
        />
        <GraphStatsBox
          title={"Offboarded"}
          count={requestData?.off_boarded_count}
          dataList={requestData?.data_list?.map((item: any) => item?.max_offboarded_count) || []}
        />
      </Box>
    </Box>
  );
};

export default DaGraphSection;
